export default __webpack_public_path__ + "media/images/react_icons/arrow-down-9827a179c1f998f80e61638ad808e283.svg";